(() => {
  const mount = widget => {
    if (widget.dataset.rnlReviewsMounted) return;
    widget.dataset.rnlReviewsMounted = 'true';
    const summary = document.querySelector('.rl-review-summary[data-review-state]');
    const label = widget.dataset.reviewHeading;
    const setState = (element, state) => {
      if (!element) return;
      if (element.dataset.reviewState !== state) element.dataset.reviewState = state;
      element.hidden = state !== 'populated';
    };
    const sync = () => {
      const inner = widget.querySelector('.jdgm-rev-widg');
      const rawCount = inner?.getAttribute('data-number-of-reviews');
      const badge = summary?.querySelector('.jdgm-prev-badge');
      const badgeCount = badge?.getAttribute('data-number-of-reviews');
      const actualCount = rawCount === null || rawCount === undefined ? badgeCount : rawCount;
      const count = /^\d+$/.test(actualCount || '') ? Number(actualCount) : null;
      const state = count === null ? 'pending' : count > 0 ? 'populated' : 'empty';
      setState(widget, state);
      setState(summary, state);
      const heading = widget.querySelector('.jdgm-rev-widg__title');
      if (heading && label && heading.textContent.trim() !== label) heading.textContent = label;
      const control = summary?.querySelector('.jdgm-preview-badge');
      if (control && state === 'populated') {
        if (control.getAttribute('role') !== 'link') control.setAttribute('role', 'link');
        if (control.getAttribute('tabindex') !== '0') control.setAttribute('tabindex', '0');
        if (control.getAttribute('aria-label') !== label) control.setAttribute('aria-label', label);
      }
      widget.querySelectorAll('.jdgm-rev').forEach(review => {
        const author = review.querySelector('.jdgm-rev__author-wrapper');
        const verified = review.querySelector('.jdgm-rev__buyer-badge-wrapper');
        if (author && verified && verified.parentNode !== author) author.append(verified);
      });
      widget.querySelectorAll('.jdgm-rev__reply').forEach(reply => {
        const content = reply.querySelector('.jdgm-rev__reply-content');
        const replyLabel = widget.dataset.reviewReplyLabel;
        const state = content?.textContent.trim() ? 'populated' : 'empty';
        if (reply.dataset.rnlReplyState !== state) reply.dataset.rnlReplyState = state;
        if (state !== 'populated' || !replyLabel) return;
        let heading = reply.querySelector('.rnl-review-reply-label');
        if (!heading) {
          heading = document.createElement('p');
          heading.className = 'rnl-review-reply-label';
          reply.insertBefore(heading, content);
        }
        if (heading.textContent !== replyLabel) heading.textContent = replyLabel;
      });
      widget.querySelectorAll('.jdgm-sort-dropdown option').forEach(option => {
        if (!['most-recent', 'highest-rating', 'lowest-rating', 'most-helpful'].includes(option.value)) option.remove();
      });
      const histogram = widget.querySelector('.jdgm-histogram');
      if (histogram && !histogram.closest('.rnl-rating-panel')) {
        const header = widget.querySelector('.jdgm-rev-widg__header');
        const sort = header?.querySelector('.jdgm-rev-widg__sort-wrapper');
        if (header && sort) {
          const panel = document.createElement('div');
          panel.className = 'rnl-rating-panel';
          panel.id = 'rnl-rating-panel-' + widget.dataset.id;
          panel.hidden = true;
          const toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'rnl-rating-toggle';
          toggle.textContent = widget.dataset.breakdownLabel;
          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('aria-controls', panel.id);
          toggle.addEventListener('click', () => {
            panel.hidden = !panel.hidden;
            toggle.setAttribute('aria-expanded', String(!panel.hidden));
          });
          header.insertBefore(toggle, sort);
          panel.append(histogram);
          header.append(panel);
        }
      }
    };
    const showReviews = event => {
      if (widget.dataset.reviewState !== 'populated' || !event.target.closest('.jdgm-preview-badge')) return;
      if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      event.stopPropagation();
      widget.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    };
    if (summary) {
      summary.addEventListener('click', showReviews, true);
      summary.addEventListener('keydown', showReviews, true);
    }
    const observer = new MutationObserver(sync);
    const options = {childList: true, subtree: true, attributes: true, attributeFilter: ['data-number-of-reviews']};
    observer.observe(widget, options);
    if (summary) observer.observe(summary, options);
    sync();
  };
  const init = () => document.querySelectorAll('#judgeme_product_reviews.rnl-client-reviews').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
